import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Nick
 * id 01E01742-E5ED-4E63-9F19-48CBE619C7A5
 * name gate-and
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gate-and.svg
 * tags
 */
export const GateAndIcon = createSvgIcon(<><path d="M2,4V20H14A8,8 0 0,0 22,12A8,8 0 0,0 14,4H2M4,6H14A6,6 0 0,1 20,12A6,6 0 0,1 14,18H4V6Z" /></>, 'GateAndIcon');
export default GateAndIcon